export default __webpack_public_path__ + "static/media/user-2.71c6bd15.svg";